import { WSEmptyStateProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSEmptyState/WSEmptyState";
import {
  BackgroundCheck,
  BackgroundCheckStatus
} from "@wingspanhq/wingspan-api-sdk";

import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";
import { RequirementTableItemData } from "../../../../types";

export const payeeBackgroundCheckRenderCardDescription = (
  requirement: RequirementTableItemData,
  backgroundCheck?: BackgroundCheck
) => {
  const descriptions: Record<BackgroundCheckStatus, WSEmptyStateProps> = {
    [BackgroundCheckStatus.NEW]: {
      type: "search",
      title: "Background check is pending",
      description: "Waiting for the contractor to start the process."
    },
    [BackgroundCheckStatus.PENDING]: {
      type: "search",
      title: "Background check is pending",
      description:
        "The contractor received an email with instructions and a background check invite link that expires 14 days after the initial invite."
    },
    [BackgroundCheckStatus.PROCESSING]: {
      type: "search",
      title: "The background check is being processed",
      description:
        "This typically takes 1-3 business days. You will be notified when it is complete."
    },
    [BackgroundCheckStatus.SUCCESS]: {
      type: "done",
      title: "The background check is complete",
      description: "The report can be accessed in the background check portal."
    },
    [BackgroundCheckStatus.FAILED]: {
      type: "search",
      title: "Something went wrong with the background check",
      description:
        "Please review the report if available. You can restart the process or mark requirement as complete."
    }
  };

  return mapStatusesToCardDetails({
    requirement,
    documentStatus: backgroundCheck?.status || BackgroundCheckStatus.NEW,
    documentStatuses: descriptions,
    pendingApprovalStatus: null,
    rejectedStatus: null,
    approvedStatus: null
  });
};
